module.exports = __webpack_public_path__ + "static/media/education_higher.2870389e.jpg";